(() => {
  'use strict';

  function initShell(shell) {
    if (!shell || shell.dataset.navigationInitialized) return;
    shell.dataset.navigationInitialized = 'true';

    const select = shell.querySelector('[data-wildlife-page-shell-nav]');
    if (!select) return;

    select.addEventListener('change', () => {
      const target = document.getElementById(select.value);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function start(root = document) {
    root.querySelectorAll?.('[data-wildlife-page-shell]').forEach(initShell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start());
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', event => start(event.target));
})();
